// Legacy component - wraps InputFieldV2
import InputFieldV2 from "./InputFieldV2";

const InputField = (props) => {
  return <InputFieldV2 {...props} />;
};

export default InputField;

